import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  QueryList,
  ViewChildren,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { RowHeightService } from '../../service/rowheight.service';

function get<T, Default>(
  object: T,
  path: string | string[],
  defaultValue?: Default
): any {
  const keys = Array.isArray(path) ? path : path.split('.');
  let result: any = object;
  for (const key of keys) {
    result = result && key in result ? result[key] : undefined;
    if (result === undefined) {
      return defaultValue;
    }
  }
  return result;
}

@Component({
  selector: '[stdoutMobileTableRow]',
  template: `
    <div>
      <div
        (click)="expand.emit(); registerMyTarget($event)"
        class="cursor-pointer bg-primary rounded-xl p-2 text-large text-tertiary"
      >
        <div class="flex pointer-events-none items-center">
          <!-- <div><std-checkbox></std-checkbox></div> -->
          <div class="text-medium text-white">{{ tableTitle }}</div>
          @if(!(index == mobileItemExpanded)){
          <svg
            class="ml-auto"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.67822 5.95538L8.1792 10.4564L12.6802 5.95538"
              stroke="white"
              stroke-width="1.00189"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          } @if((index == mobileItemExpanded)){
          <svg
            class="ml-auto"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.71265 10.4562L8.21363 5.9552L12.7146 10.4562"
              stroke="white"
              stroke-width="1.00189"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          }
        </div>
      </div>
      <div
        [style]="'height:' + (index == mobileItemExpanded ? getH() : '0px')"
        [class]="'overflow-hidden transition-all'"
      >
        <div name="mobileElement">
          <div
            [ngClass]="getTdClasses(column)"
            [style.opacity]="column.selected ? 0.5 : 1"
            *ngFor="
              let column of columns;
              let colIndex = index;
              let last = last
            "
            [style.opacity]="column.selected ? 0.5 : 1"
            [class]="
              'w-full text-medium flex items-center ' +
              (last ? '' : 'border-b-[2px] border-primary')
            "
            style="word-break: break-word"
          >
            <div class="font-semibold text-right pr-2">{{ column.label }}:</div>
            <span
              *ngIf="column.cellTemplate"
              [ngTemplateOutletContext]="{
                column: column,
                item: item,
                index: index
              }"
              [ngTemplateOutlet]="column.cellTemplate"
            >
            </span>
            <span
              *ngIf="!column.cellTemplate"
              [textContent]="getPropertyFromKeys(column.property)"
            >
            </span>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MobileTableRowComponent implements AfterViewInit {
  @Input() item: any;
  @Input() index!: number;
  @Input() columns: any;
  @Input() mobileItemExpanded!: number;
  @Input() tableTitle!: string;
  @Output() expand: EventEmitter<void> = new EventEmitter();
  myTarget!: HTMLElement | null;
  constructor(private rowHeightService: RowHeightService) {}

  registerMyTarget(event: Event) {
    if (event.target) {
      this.myTarget = event.target as HTMLElement | null;
    }
  }

  getH() {
    if (this.myTarget) {
      let myElement = this.myTarget.parentElement?.querySelector(
        'div[name="mobileElement"]'
      );
      return myElement?.clientHeight + 'px';
    } else {
      return '0px';
    }
  }

  getTdClasses(column: any) {
    const classes: any = {
      'py-2 px-1 md:!py-2.5 md:!px-3.5 break-words': true,
    };
    if (column?.classes) {
      classes[column.classes] = true;
    }

    return classes;
  }

  getPropertyFromKeys(key: any) {
    return get(this.item, key);
  }

  ngAfterViewInit() {}
}
